// extracted by mini-css-extract-plugin
export default {"yourCall":"YourCall_yourCall__t2oz0"};